import api from "./api";


const inquireResourceGroup=async() =>{
	
	const apiPath = `/resource/inquireresourcegroup`;
	console.log("inquireResourceGroup " + apiPath);
	const response = api.get(apiPath);
	return response;
}

const inquireResourcesbyGroup=async(groupName) =>{
	
	const apiPath = `/resource/inquireresourcesbygroup/${groupName}`;
	console.log("inquireResourcesbyGroup " + apiPath);
	const response = api.get(apiPath);
	return response;
}

const inquireResource=async(resourceCode) =>{
	
	const apiPath = `/resource/inquireresource/${resourceCode}`;
	console.log("inquireresource " + apiPath);
	const response = api.get(apiPath);
	return response;
}
const updateResource = (apiParams) => {

	const apiPath = `/resource/updateresource`;

	console.log("updateResource " + apiPath);
	let url = apiPath;
	let data = apiParams;

	const response = api.post(url, data);
	return response;
}


const ResourceService = {
	inquireResourceGroup,
	inquireResourcesbyGroup,
	inquireResource,
	updateResource,	
};

export default ResourceService;
